'use strict';

var React = require('react');
var LinkHelper = require('./LinkHelper');
var appTypes = require('../../types/appTypes');
var _ = require('underscore');

var LinkArea = React.createClass({
  propTypes: {
    links: React.PropTypes.object.isRequired,
    interactive: React.PropTypes.object,
    size: React.PropTypes.object.isRequired,
    externalURL: React.PropTypes.string,
    onLinkEvent: React.PropTypes.func.isRequired,
    onLongPressEvent: React.PropTypes.func.isRequired,
    key: React.PropTypes.string
  },

  longPress: false,

  isLongPress: false,

  getLinkAreaArray: function () {
    var i;
    var link;
    var linkItem;
    var resultLinkArray = [];

    var entry;
    var events;

    if (!this.props.links && !this.props.interactive) {
      return resultLinkArray;
    }

    if (this.props.links.link) {

      for (i = 0; i < this.props.links.link.length; i++) {
        link = this.props.links.link[i];
        linkItem = {};

        if (link.targetPageID && link.linkType === appTypes.PageLinkType.PAGE_LINK) {
          linkItem.index = i;
          linkItem.linkCoords = link.area.coords;
        }

        if (this.props.interactive) {
          entry = this.props.interactive.entry[i];
          if (entry) {
            events = entry.events;
            if (events && events.event && events.event.length) {
              linkItem.index = i;
              if(this.isChecked(entry))
                linkItem.interactiveCoords = entry.area.coords;
            }
          }
        }


        if (!_.isEmpty(linkItem)) {
          resultLinkArray.push(linkItem);
        }

      }
    }

    return resultLinkArray;

  },

  isChecked : function(entry){
    var i;
    var j;
    var c = false;
    var e;
    var t;
    var b;
    if(entry.events && entry.events.event){
      for(i = 0;i<entry.events.event.length;i++){
        e = entry.events.event[i];
        if(e.isChecked){
          b = e.behaviour[0];
          for(j = 0;j< b.target.length;j++){
            t = b.target[j];
            if(t &&　t.isChecked){
              c = true;
              break;
            }
          }
          if(c){
            break;
          }
        }
      }
    }
    return c;
  },

  /**
   * 触发页面链接
   * @param index
   * @param evt
   * @private
   */
  _onPageLinkEvent: function (index, evt) {
    this.props.onLinkEvent(evt, appTypes.ActionResponseType.LINK, index);
    this._onExternalLinkEvent(evt);
    evt.stopPropagation();
  },
  /**
   * 触发双击交互
   * @param index
   * @param evt
   * @private
   */
  _onDblClick: function (index, evt) {
    evt.stopPropagation();
    if (this.props.onDblClick) {
      this.props.onDblClick(evt, index);
    }
  },

  /**
   * 触发右键点击交互
   * @param index
   * @param evt
   * @private
   */
  _onRightClick: function (index, evt) {
    if (this.props.onRightClick) {
      this.props.onRightClick(evt, index);
    }
  },

  _onMouseDown: function (index, evt) {
    if (evt.button === 0) {
      this.mousePress = true;
      this.isLongPress = false;
      this.startListernLongPress(index, evt);
    } else if (evt.button === 2) {
      this.rightDownIndex = index;
    }
  },

  _onMouseUp: function (index, evt) {
    this.mousePress = false;
    this._stopListernLongPress();
    if (this.rightDownIndex === index) {
      delete this.rightDownIndex;
      this._onRightClick(index);
    }
  },

  _onContextMenu: function (evt) {
    evt.nativeEvent.returnValue = false;
    return false;
  },

  _stopListernLongPress: function () {
    if (this.timeID) {
      clearTimeout(this.timeID);
    }
    delete this.timeID;
  },

  /**
   * 触发长按事件
   * @param index
   * @param evt
   */
  startListernLongPress: function (index, evt) {
    var self = this;
    if (LinkHelper.hasLongPressEvents(self.props.interactive, index)) {
      this.timeID = setTimeout(function () {
        self.isLongPress = true;
        self._stopListernLongPress();
        if (self.mousePress) {
          if (self.props.onLongPressEvent) {
            self.props.onLongPressEvent(evt, index);
          }
        }
      }, 800);
    }
  },


  /**
   * 触发点击交互
   * @param index
   * @param evt
   * @private
   */
  _onInteractiveLinkEvent: function (index, evt) {
    //evt.stopPropagation();
    if (this.isLongPress) {
      evt.stopPropagation();
      return;
    }
    this.props.onLinkEvent(evt, appTypes.ActionResponseType.INTERACTIVE, index);
    this._onExternalLinkEvent(evt);
  },

  /**
   * 触发外部链接
   * @param evt
   * @private
   */
  _onExternalLinkEvent: function (evt) {
    if (this.props.externalURL) {
      this.props.onLinkEvent(evt, appTypes.ActionResponseType.OUTER);
    }
  },

  createPageLinkArea: function (coordinate, index) {
    var divStyle = {
      left: coordinate.left,
      top: coordinate.top,
      width: coordinate.width,
      height: coordinate.height
    };

    return (<div
      className="page-link"
      key={index}
      style={divStyle}
      onClick={this._onPageLinkEvent.bind(this, index)}
    />)
  },

  createInteractiveLinkArea: function (coordinate, index) {
    var divStyle = {
      left: coordinate.left,
      top: coordinate.top,
      width: coordinate.width,
      height: coordinate.height
    };

    return (<div
      className="interactive-link"
      key={index}
      style={divStyle}
      onDoubleClick={this._onDblClick.bind(this,index)}
      onMouseDown={this._onMouseDown.bind(this,index)}
      onMouseUp={this._onMouseUp.bind(this,index)}
      onClick={this._onInteractiveLinkEvent.bind(this, index)}
      onContextMenu={this._onContextMenu}
    ></div>)
  },

  render: function () {
    var linkArray = this.getLinkAreaArray();
    var divStyle;
    var _this = this;

    if (linkArray && linkArray.length) {
      divStyle = {
        width: 0,//this.props.size.w,
        height: 0//this.props.size.h
      };
      return (<div
        className='linkArea'
        onClick={this._onExternalLinkEvent}
        key={this.props.key}
        id={this.props.key}
        style={divStyle}>
        {
          linkArray.map(function (item) {
            if (item.linkCoords) {
              return _this.createPageLinkArea(item.linkCoords, item.index);
            } else if (item.interactiveCoords) {
              return _this.createInteractiveLinkArea(item.interactiveCoords, item.index);
            }
          })
        }
      </div>);
    }

    return (<div key={this.props.key} style={{
      display: 'none'
    }}></div>);
  }
});

module.exports = LinkArea;




// WEBPACK FOOTER //
// ./src/views/common/LinkArea.jsx